(function () {
  class MultiplierViewRight extends PIXI.Container {
    constructor() {
      super();

      this.initialised = false;
      this.multiplierActive = false;
      this.boostActive = false;

      const self = this;

      StateMachine.Create(this);

      Reflex.addToUpdate(function () {
        self.update();
      });

      this.stateMachine.addState("IDLE", function () {});
      this.stateMachine.addState("INITIALMULTIPLIER", function () {
        self.updateInitialMultiplier();
      });
      this.stateMachine.addState("INCREASEMULTIPLIER", function () {
        self.updateIncreaseMultiplier();
      });
      this.stateMachine.addState("RESET_MULTIPLIER", function () {
        self.updateResetMultiplier();
      });
      this.stateMachine.addState("STARTBOOSTMULTIPLIER", function () {
        self.boostMultiplier();
      });
      this.stateMachine.addState("BOOST_MULTIPLIER", function () {
        self.updateBoostMultiplier();
      });

      this.boostByAmount = 10;

      this.resetMultiplierValues();

      this.baseScales = [1, 0.7, 0.55];
      this.lengthScales = [1, 0.74, 0.62, 0.5, 0.38];
    }

    initialise() {
      const self = this;

      messageBus.subscribe("spinner:GameConfigEvent", function () {
        self.onLayoutComplete();
      });
    }

    addMessageListeners() {
      messageBus.subscribe("Game:boostMulti", this.boostMultiplier.bind(this));

      Reflex.registerEventHandler(
        "orientationChange",
        this.onOrientationChange.bind(this)
      );
    }

    onLayoutComplete() {
      var baseName = "multiplierViewRight:MultiplierViewRight:";

      this.arrows = [];

      for (let i = 0; i < 3; i++) {
        this.arrows[i] = resourceManager.get(
          baseName + `multiplierArrows:arrow${i + 1}`
        );
        this.arrows[i].visible = false;
      }

      this.resetMultiplierArrows();

      // Duplicate
      this.multiplierDuplicate = resourceManager.get(
        baseName + "multiplierDuplicate"
      );

      this.duplicateText = resourceManager.get(
        baseName + "multiplierDuplicate:multiplierDuplicateTextOff"
      );

      this.duplicatePos = {
        x: this.multiplierDuplicate.x,
        y: this.multiplierDuplicate.y,
      };

      // Back
      this.multiplierBack = resourceManager.get(baseName + "multiplierBack");

      this.backText = resourceManager.get(
        baseName + "multiplierBack:multiplierBackTextOff"
      );

      this.backPos = {
        x: this.multiplierBack.x,
        y: this.multiplierBack.y,
      };

      // Mid
      this.multiplierMid = resourceManager.get(baseName + "multiplierMid");

      this.midText = resourceManager.get(
        baseName + "multiplierMid:multiplierMidTextOff"
      );

      this.midPos = { x: this.multiplierMid.x, y: this.multiplierMid.y };

      // Blast Anim
      this.blastAnim = resourceManager.get(baseName + "blastAnim");
      this.blastAnim.gotoAndStop(0);
      this.gemAnim = resourceManager.get(baseName + "gemAnim");
      this.gemAnim.gotoAndStop(0);

      // Front
      this.multiplierFront = resourceManager.get(baseName + "multiplierFront");

      this.frontText = [
        resourceManager.get(
          baseName + "multiplierFront:multiplierFrontTextOff"
        ),
        resourceManager.get(baseName + "multiplierFront:multiplierFrontTextOn"),
      ];

      this.frontPos = { x: this.multiplierFront.x, y: this.multiplierFront.y };

      this.setMultiplierActive(false);
      this.setLayoutScaleFactor(this.multipliers);
      this.createTweens();

      this.setupInitialScales();

      this.updateMultiplierText();

      this.addMessageListeners();
    }

    createTweens() {
      var duration = 0.2;

      this.boostMultipliersTimeline = gsap
        .timeline({ paused: true })
        .call(() => {
          soundManager.play("multiplierIncrease");
        })
        .to(this.multiplierFront.scale, {
          duration,
          x: 0,
          y: 0,
        })
        .to(
          this.multiplierMid.scale,
          {
            duration,
            x: 0,
            y: 0,
          },
          "<+=0.1"
        )
        .to(
          this.multiplierBack.scale,
          {
            duration,
            x: 0,
            y: 0,
          },
          "<+=0.1"
        )
        .call(() => {
          this.addMultiplierBoostX10();
          this.blastAnim.gotoAndPlay(0);
          this.boostAnimation(duration);
        });

      this.arrowTimeline = gsap.timeline({ paused: true }).call(() => {
        this.resetMultiplierArrows();
      });

      this.arrows.forEach((arrow) => {
        this.arrowTimeline.to(
          arrow.scale,
          {
            duration: 0.2,
            x: 1,
            y: 1,
            yoyo: true,
            repeat: 1,
            onStart: () => {
              arrow.visible = true;
            },
            onComplete: () => {
              arrow.visible = false;
            },
          },
          "<+=0.15"
        );
      });
    }

    resetMultiplierValues() {
      this.multiplierIndex = 4;
      this.multipliers = [1, 2, 4, 7]; // front, middle, back, duplicate
    }

    resetMultiplierArrows() {
      this.arrows.forEach((arrow) => {
        arrow.scale = { x: 0, y: 0 };
      });
    }

    boostAnimation(duration) {
      // This cannot be part of the timeline as timeline variables get cached
      // And we don't want the scales cached as we don't know them yet
      gsap.to(this.multiplierFront.scale, {
        duration,
        x: this.frontScale,
        y: this.frontScale,
      });

      gsap.to(
        this.multiplierMid.scale,
        {
          duration,
          x: this.midScale,
          y: this.midScale,
        },
        "<+=0.1"
      );

      gsap.to(
        this.multiplierBack.scale,
        {
          duration,
          x: this.backScale,
          y: this.backScale,
        },
        "<+=0.1"
      );
    }

    setLayoutScaleFactor(multipliers) {
      this.frontScale =
        this.baseScales[0] * this.getMultiplierSize(multipliers[0]);
      this.midScale =
        this.baseScales[1] * this.getMultiplierSize(multipliers[1]);
      this.backScale =
        this.baseScales[2] * this.getMultiplierSize(multipliers[2]);
    }

    setupInitialScales() {
      this.multiplierDuplicate.scale.set(0);
      this.multiplierBack.scale.set(this.backScale);
      this.multiplierMid.scale.set(this.midScale);
      this.multiplierFront.scale.set(this.frontScale);

      this.setMultiplierScale(this.frontScale, this.midScale, this.backScale);
    }

    hideMultipliers() {}

    boostMultiplier(task) {
      this.boostActive = true;
      this.stateMachine.switchState("BOOST_MULTIPLIER");
    }

    setMultiplierPositions() {
      this.multiplierDuplicate.position.set(
        this.duplicatePos.x,
        this.duplicatePos.y
      );
      this.multiplierBack.position.set(this.backPos.x, this.backPos.y);
      this.multiplierMid.position.set(this.midPos.x, this.midPos.y);
      this.multiplierFront.position.set(this.frontPos.x, this.frontPos.y);
    }

    moveAndScale() {
      soundManager.play("multiplierIncrease");

      var duration = 0.4;
      var shrinkPos = this.frontPos.y + 80;
      var newBackScale =
        this.baseScales[2] * this.getMultiplierSize(this.multipliers[3]);
      var newMidScale =
        this.baseScales[1] * this.getMultiplierSize(this.multipliers[2]);
      var newFrontScale =
        this.baseScales[0] * this.getMultiplierSize(this.multipliers[1]);

      gsap.to(this.multiplierFront, {
        duration,
        y: shrinkPos,
      });
      gsap.to(this.multiplierFront.scale, {
        duration,
        x: 0,
        y: 0,
      });
      gsap.to(this.multiplierMid, {
        duration,
        y: this.frontPos.y,
      });
      gsap.to(this.multiplierMid.scale, {
        duration,
        x: newFrontScale,
        y: newFrontScale,
      });
      gsap.to(this.multiplierBack, {
        duration,
        y: this.midPos.y,
      });
      gsap.to(this.multiplierBack.scale, {
        duration,
        x: newMidScale,
        y: newMidScale,
      });
      gsap.to(this.multiplierDuplicate, {
        duration,
        y: this.backPos.y,
      });
      gsap.to(this.multiplierDuplicate.scale, {
        duration,
        x: newBackScale,
        y: newBackScale,
        onComplete: () => {
          this.moveAndScaleComplete();
        },
      });
    }

    moveAndScaleComplete() {
      this.incrementMultipliers();
      this.updateMultiplierText();
      this.setFinalScaleAndPosition();
      this.onOrientationChange();
      this.setMultiplierActive(false);
    }

    setFinalScaleAndPosition() {
      this.setMultiplierPositions(
        this.frontPos,
        this.midPos,
        this.backPos,
        this.duplicatePos
      );

      this.setMultiplierScale(this.frontScale, this.midScale, this.backScale);
    }

    addMultiplierBoostX10() {
      this.addBoostToMultipliers(true);
      this.updateMultiplierText();
    }

    updateBoostMultiplier() {
      if (this.phase.enter()) {
      }

      if (this.phase.timed(750)) {
      }

      if (this.phase.once()) {
        this.boostMultipliersTimeline.play(0);
      }

      if (this.phase.timed(1000)) {
      }

      if (this.phase.once()) {
        this.currentStep = 0;
        this.targetStep = 0;

        this.stateMachine.switchState("IDLE");
      }
    }

    showMultipliers() {}

    startMultiplierAnim() {
      this.arrowTimeline.play(0);
    }

    increaseMultiplier() {
      this.stateMachine.switchState("INCREASEMULTIPLIER");
    }

    resetMultiplier() {
      this.stateMachine.switchState("RESET_MULTIPLIER");
    }

    getMultiplier() {
      return this.multipliers;
    }

    updateMultiplierText() {
      this.frontText.forEach((text) => {
        text.text = "x" + this.multipliers[0];
      });
      this.midText.text = "x" + this.multipliers[1];
      this.backText.text = "x" + this.multipliers[2];
      this.duplicateText.text = "x" + this.multipliers[3];

      this.setLayoutScaleFactor(this.multipliers);
    }

    setMultiplierScale(frontScale, midScale, backScale) {
      this.multiplierDuplicate.scale.set(0);

      this.multiplierBack.scale.set(backScale);

      this.multiplierMid.scale.set(midScale);

      this.multiplierFront.scale.set(frontScale);
    }

    incrementMultipliers() {
      var len = this.multipliers.length - 1;

      for (let i = 0; i < this.multipliers.length - 1; i++) {
        this.multipliers[i] = this.multipliers[i + 1];
      }
      this.multipliers[len] += this.multiplierIndex;
      this.multiplierIndex++;
    }

    addBoostToMultipliers() {
      for (let i = 0; i < this.multipliers.length; i++) {
        this.multipliers[i] += this.boostByAmount;
      }
    }

    updateIncreaseMultiplier() {
      if (this.phase.enter()) {
      }

      if (this.phase.once()) {
        this.moveAndScale();
      }

      if (this.phase.timed(1000)) {
      }

      if (this.phase.once()) {
        this.stateMachine.switchState("IDLE");
      }
    }

    updateResetMultiplier() {
      if (this.phase.enter()) {
      }

      if (this.phase.timed(150)) {
        let newFrontScale = this.frontScale * (1 - this.phase.Progress);
        let newMidScale = this.midScale * (1 - this.phase.Progress);
        let newBackScale = this.backScale * (1 - this.phase.Progress);

        this.setMultiplierScale(newFrontScale, newMidScale, newBackScale);
      }

      if (this.phase.timed(100)) {
      }

      if (this.phase.once()) {
        this.resetMultiplierValues();
        this.updateMultiplierText();
        this.setMultiplierScale(this.frontScale, this.midScale, this.backScale);
        this.setMultiplierActive(false);
      }

      if (this.phase.timed(150)) {
        this.setLayoutScaleFactor(this.multipliers);

        let frontScaleIn = this.frontScale * this.phase.Progress;
        let midScaleIn = this.midScale * this.phase.Progress;
        let backScaleIn = this.backScale * this.phase.Progress;

        this.setMultiplierScale(frontScaleIn, midScaleIn, backScaleIn);
      }

      if (this.phase.once()) {
        let frontScale = this.frontScale;
        let midScale = this.midScale;
        let backScale = this.backScale;

        this.setMultiplierScale(frontScale, midScale, backScale);

        this.multiplierActive = false;
        this.stateMachine.switchState("IDLE");
      }
    }

    updateInitialMultiplier() {
      if (this.phase.enter()) {
        this.multiplierActive = true;
      }

      if (this.phase.once()) {
        this.moveAndScale();
      }

      if (this.phase.timed(1000)) {
      }

      if (this.phase.once()) {
        this.setFinalScaleAndPosition();
        this.stateMachine.switchState("IDLE");
      }
    }

    setMultiplierActive(active) {
      this.frontText[0].visible = !active;
      this.frontText[1].visible = active;
    }

    pulseMultiplierWinTxtTween() {
      gsap.to(this.multiplierFront.scale, {
        duration: 0.15,
        ease: "linear",
        x: this.frontScale * 1.4,
        y: this.frontScale * 1.4,
        yoyo: true,
        repeat: 3,
        onStart: () => {
          this.gemAnim.gotoAndPlay(0);
        },
      });

      this.setMultiplierActive(true);
    }

    getMultiplierSize(multiplier) {
      if (multiplier < 10) {
        return this.lengthScales[0];
      } else if (multiplier < 100) {
        return this.lengthScales[1];
      } else if (multiplier < 1000) {
        return this.lengthScales[2];
      } else if (multiplier < 10000) {
        return this.lengthScales[3];
      } else {
        return this.lengthScales[4];
      }
    }

    onOrientationChange() {
      this.frontPos = { x: this.multiplierFront.x, y: this.multiplierFront.y };
      this.midPos = { x: this.multiplierMid.x, y: this.multiplierMid.y };
      this.backPos = { x: this.multiplierBack.x, y: this.multiplierBack.y };
      this.duplicatePos = {
        x: this.multiplierDuplicate.x,
        y: this.multiplierDuplicate.y,
      };

      this.setLayoutScaleFactor(this.multipliers);

      this.setupInitialScales();
    }

    update() {
      if (this.stateMachine) {
        this.stateMachine.update();
      }
    }
  }

  create = function (json) {
    return new MultiplierViewRight();
  };

  initialise = function (json, container, resources) {
    container.initialise();
  };

  getFilesRequired = function (json) {
    return ["", ""];
  };

  resourceManager.registerObjectType(
    "MultiplierViewRight",
    create,
    initialise,
    getFilesRequired
  );
})();
